import { render, staticRenderFns } from "./CoreValue.vue?vue&type=template&id=203d8f7c&scoped=true&functional=true&"
import script from "./CoreValue.vue?vue&type=script&lang=js&"
export * from "./CoreValue.vue?vue&type=script&lang=js&"
import style0 from "./CoreValue.vue?vue&type=style&index=0&id=203d8f7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "203d8f7c",
  null
  
)

export default component.exports